<template>
    <v-card class="pa-5 modal-info--position js-inner-card" :style="$vuetify.breakpoint.lgAndUp ? 'width:752px' : ''">
        <v-icon class="modal-close" @click.native="CLOSE_MODAL(crosslink_detail_modal)">close</v-icon>
        <v-layout class="mt-4">
            <div class="mt-4">
                <img v-if="database_inner_modal.image" :src="database_inner_modal.image" alt="">
            </div>
            <v-flex column>
                <v-card-title class="display-1 my-4">{{ database_inner_modal.title }}</v-card-title>
                <!-- <v-layout row wrap align-content-end>
                    <v-flex xs6 :class="{'sm3': !database_inner_modal.image}">
                        <v-layout column>
                            <v-flex class="grey-text mb-1">{{$t("Дата добавления")}}:</v-flex>
                            <v-flex>{{ get_date(database_inner_modal.add_date) }}</v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs6 :class="{'sm3': !database_inner_modal.image}">
                        <v-layout column>
                            <v-flex class="grey-text mb-1">{{$t("Дата обновления")}}:</v-flex>
                            <v-flex>{{ get_date(database_inner_modal.update_date) }}</v-flex>
                        </v-layout>
                    </v-flex>

                    <v-flex v-if="database_inner_modal.links" class="xs12 mt-3">
                        <v-layout>
                            <linkGreen v-for="(link,i) in database_inner_modal.links" :key="i" class="mr-3">{{ link.title }}</linkGreen>
                        </v-layout>
                    </v-flex>
                    <v-layout align-end :class="{'mt-3': $vuetify.breakpoint.xs, 'flex md3 mt-4': database_inner_modal.image}">
                        <iconLabel icon_name="heart" class="icon-label-red align-content-end" size="23">{{ database_inner_modal.likes || 0 }}</iconLabel>
                    </v-layout>
                    <v-layout align-end :class="{'mt-3': $vuetify.breakpoint.xs, 'flex md5 mt-4': database_inner_modal.image}">
                        <iconLabel :icon_name="database_inner_modal.favourite ? 'in-favorites' : 'favorites'" class="icon-label-red align-content-end" size="23"
                                   @click.native="toggle_favourites(database_inner_modal)"
                        >{{ $t("В избранное") }}</iconLabel>
                    </v-layout>
                </v-layout> -->
            </v-flex>
        </v-layout>
        <v-layout row wrap my-4>
            <template v-for="(block, i) in database_inner_modal.content">
                <component v-if="block.type!=='crossLinks'" :key="i" :content="block.content"
                           :is="block.type"
                />
            </template>
        </v-layout>
        <!-- <v-card-actions>
            <v-layout wrap>
                <buttonRed class="flex md6" :class="{'xs12 mr-0': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp}"
                           @click.native="OPEN_MODAL(improve_database_article)"
                >{{ $t("Предложить улучшение статьи") }}</buttonRed>
                <buttonBdWhite class="flex md5" :class="{'xs12 mt-3': $vuetify.breakpoint.xs}" @click.native="OPEN_CONTACT_MODAL()">{{ $t("Задать вопрос") }}</buttonBdWhite>
            </v-layout>
            <v-dialog :value="improve_database_article.active" persistent content-class="scrolled-dialog">
                <databaseImproveArticle v-if="improve_database_article.active" :title="database_inner_modal.title" />
            </v-dialog>
        </v-card-actions> -->
    </v-card>
</template>

<script>
import buttonRed from '@/components/ui/buttons/button_red';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import linkGreen from '@/components/ui/links/styled/link_green';
import iconLabel from '@/components/ui/icons/icon_with_label';
import documents from '@/components/blocks/content_blocks/block_documents.vue';
import slider from '@/components/blocks/content_blocks/block_slider.vue';
import links from '@/components/blocks/content_blocks/block_links.vue';
import crossLinks from '../list_blocks/cross_links.vue';
import htmlText from '@/components/blocks/content_blocks/block_text.vue';
import plainText from '@/components/blocks/content_blocks/block_text.vue';
import list from '@/components/view_blocks/Database/list_blocks/list';
import databaseImproveArticle from './Database_improve_article';
import sliderModal from '@/components/blocks/content_blocks/slider_modal';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';

dayjs.extend(utc);

export default {
  components: {
    buttonRed,
    buttonBdWhite,
    linkGreen,
    iconLabel,
    plainText,
    htmlText,
    documents,
    slider,
    links,
    list,
    databaseImproveArticle,
    sliderModal,
    crossLinks,
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters('common/modals', [
      'slider_modal',
    ]),
    ...mapGetters('database/modal', [
      'database_inner_modal',
      'database_modal',
      'crosslink_detail_modal',
      'improve_database_article',
      'current_inner',
    ]),
    ...mapGetters('database', [
      'current_tab',
    ]),
  },
  beforeCreate() {
    // если карточка не выходит за границы окна, надо делать отступ как от скролла
    // document.documentElement.style.overflow = 'hidden';
  },
  beforeDestroy() {
    // document.documentElement.style.overflow = 'auto';
  },
  mounted() {
    let obj = {type: this.current_inner.type, id: this.current_inner.id};
    this.get_inner_detail(obj);
  },
  methods: {
    ...mapMutations('contact/requests', [
      'OPEN_CONTACT_MODAL',
    ]),
    ...mapMutations('database/modal', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
    ...mapActions('database/modal', [
      'get_inner_detail',
    ]),
    ...mapActions('favourites', [
      'toggle_favourites',
    ]),
    get_date(date) {
      return new dayjs(parseInt(date*1000)).utc().format('DD.MM.YYYY');
    },
    get_time(date) {
      return new dayjs(parseInt(date*1000)).utc().format('HH.mm');
    },
  },

};
</script>
<style lang="less" scoped>
// .js-inner-card {
//   transform: translateX(-8px);
// }
</style>
